import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${token('space.200')};
	padding: 0 4px;
`;

export const AddBanner = styled.div`
    border: 1px dashed ${token('color.border')};
    border-radius: 3px;
    background: ${token('color.background.accent.gray.subtlest')};
    cursor: pointer;
    display: flex;
    justify-content: center;
    color: ${token('color.text.accent.blue')};
    font-size: 14px;
    padding: 52px;
`;
